import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

addNewRelic();

if (environment.isAptyEnabled && `${environment.isAptyEnabled}` === 'true') {
  loadAptyDap();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

function loadAptyDap(): void {
  const contentURL = 'https://client.app.apty.io';
  const element = window.document.createElement('script');
  const tenantKey = 'hnZeCo7N';
  const timeStamp = new Date().getTime();
  element.setAttribute('src', contentURL + `/tenant-${tenantKey}/injected-hook.js?timestamp=${timeStamp}&token=`);
  window.document.head.appendChild(element);
}

function addNewRelic(): void {
  const contentUrl = './assets\\scripts\\new-relic-script.js?v=2';
  const element = window.document.createElement('script');

  element.setAttribute('src', contentUrl);
  window.document.head.appendChild(element);
  }
